import React from 'react';
import Fade from 'react-reveal/Fade';

function fadeIn(WrappedComponent) {
  return class PP extends React.Component {
    render() {
      return (
        <Fade>
          <WrappedComponent {...this.props} />
        </Fade>
      );
    }
  };
}

export default fadeIn;



// WEBPACK FOOTER //
// ./src/components/common/FadeIn.js